import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ToolTip extends Component {
    render() {
        const { children } = this.props;
        return (
            <div className="container tooltips__container">
                <div className="row tooltips__content">{children}</div>
            </div>
        );
    }

}

ToolTip.propTypes = {
    children: PropTypes.any
};

export default ToolTip;


// WEBPACK FOOTER //
// src/client/components/common/elements/ToolTip.js